import { useState, useMemo, useEffect, useRef } from "react";
import "./claimlanding.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Download, Eye } from "lucide-react";
import axios from "axios";

const getWorkApprovalUpdateDateFromS3 = async (claimNumber) => {
  try {
    const res = await axios.get(
      `/process_data/claim-json-last-modified/${claimNumber}`,
    );

    if (res.data?.success && res.data.lastModified) {
      // S3 se jo exact string aa rahi hai, wahi return karo
      return res.data.lastModified;
    }
    return "Not Available";
  } catch (err) {
    console.error("Failed to fetch S3 date", err);
    return "Not Available";
  }
};

const ClaimStatusList = () => {
  const navigate = useNavigate();
  const { claimNumber } = useParams();
  const closeAllModals = () => {
    setShowStepInfoModal(false);
    setShowClaimModal(false);
    setShowServeyorModal(false);
  };
  const [progressData, setProgressData] = useState();
  const [annotationProcessed, setAnnotationProcessed] = useState(false);
  const [currentStep, setCurrentStep] = useState(3);
  const [formData, setFormData] = useState({
    claim_number: "",
    email_id: "",
    phone_number: "",
    created_at: "",
    date: "",
  });

  // NEW STATE: Store image dates from CarInspection
  const [imageDates, setImageDates] = useState({
    survey_preview_date: null,
    survey_doc_date: null,
    survey_upload_date: null,
  });

  // NEW STATE: Store claim data for Work Approval date
  const [claimData, setClaimData] = useState(null);
  const [workApprovalS3Date, setWorkApprovalS3Date] = useState(null);

  const useS3FileCheck = (claimNumber) => {
    const [fileExists, setFileExists] = useState(false);
    const [isCheckingFile, setIsCheckingFile] = useState(true);

    // const checkFileExists = async () => {
    //   try {
    //     setIsCheckingFile(true)
    //     const response = await axios.get(`/server/check-s3-file`, {
    //       params: {
    //         claimNumber: claimNumber
    //       },
    //       headers: {
    //         'Content-Type': 'application/json',
    //         Authorization: `Bearer ${localStorage.getItem('token')}`
    //       }
    //     })
    //     console.log("44",response.data);

    //     if (response.status === 200) {
    //       setFileExists(response.data.exists)
    //       // Call second API
    //        const update_doc_res=  await axios.post(
    //         '/process_data/update-doc-status',
    //         { claimNumber },
    //         {
    //           headers: {
    //             Authorization: `Bearer ${localStorage.getItem('token')}`
    //           }
    //         }
    //       )
    //       console.log("56",update_doc_res.data);

    //     } else {
    //       console.error('Failed to check file:', response.statusText)
    //       setFileExists(false)
    //     }
    //   } catch (error) {
    //     console.error('Error checking file:', error)
    //     setFileExists(false)
    //   } finally {
    //     setIsCheckingFile(false)
    //   }
    // }
    const checkFileExists = async () => {
      try {
        setIsCheckingFile(true);

        const response = await axios.get("/server/check-s3-file", {
          params: { claimNumber },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        console.log("44", response.data);

        if (response.status === 200) {
          setFileExists(response.data.exists);
        } else {
          console.error("Failed to check file:", response.statusText);
          setFileExists(false);
        }
      } catch (error) {
        console.error("Error checking file:", error);
        setFileExists(false);
      } finally {
        setIsCheckingFile(false);
      }
    };

    useEffect(() => {
      if (claimNumber) {
        checkFileExists();
      }
    }, [claimNumber]);

    useEffect(() => {
      let interval;
      if (!fileExists && claimNumber && !isCheckingFile) {
        interval = setInterval(() => {
          checkFileExists();
        }, 30000);
      }

      return () => {
        if (interval) {
          clearInterval(interval);
        }
      };
    }, [fileExists, claimNumber, isCheckingFile]);

    return { fileExists, isCheckingFile, checkFileExists };
  };
  const { fileExists, isCheckingFile, checkFileExists } =
    useS3FileCheck(claimNumber);

  useEffect(() => {
    if (!claimNumber || !fileExists || !progressData) return;

    const surveyUploadDone = Number(progressData?.survey_upload) === 1;
    const surveyDocDone = Number(progressData?.survey_doc) === 1;

    if (!surveyUploadDone || !surveyDocDone) {
      console.log(
        "Skipping /process_data/update-doc-status until survey_upload and survey_doc are both 1",
      );
      return;
    }

    const updateDocStatus = async () => {
      try {
        const updateDocRes = await axios.post(
          "/process_data/update-doc-status",
          { claimNumber },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        console.log("56", updateDocRes.data);
      } catch (error) {
        console.error("Error updating doc status:", error);
      }
    };

    updateDocStatus();
  }, [claimNumber, fileExists, progressData]);

  const allClaims = JSON.parse(localStorage.getItem("claimsData")) || [];
  const claimFromState = allClaims.find(
    (claim) => claim.claimNumber === claimNumber,
  );

  const [showSurveyorModal, setShowServeyorModal] = useState(false);
  const [showClaimModal, setShowClaimModal] = useState(false);
  const [showStepInfoModal, setShowStepInfoModal] = useState(false);
  const [activeStepInfo, setActiveStepInfo] = useState(null);
  const [preFileExists, setPreFileExists] = useState(false);
  const [invoiceFileExists, setInvoiceFileExists] = useState(false);
  const [checkingCompareFile, setCheckingCompareFile] = useState(false);
  const [downloadAllLoading, setDownloadAllLoading] = useState(false);
  const [downloadAllError, setDownloadAllError] = useState("");
  const surveyDocumentsReady =
    Number(progressData?.survey_doc) === 1 &&
    Number(progressData?.survey_upload) === 1;
  // const downloadPrerequisitesReady =
  //   surveyDocumentsReady && annotationProcessed;
  const downloadPrerequisitesReady = annotationProcessed;

  useEffect(() => {
    if (!claimNumber) {
      setAnnotationProcessed(false);
      return undefined;
    }

    let isActive = true;
    let requestInFlight = false;
    let intervalId;

    const checkAnnotationStatus = async () => {
      if (requestInFlight) return;
      requestInFlight = true;
      try {
        const response = await axios.post(
          "/process_data/check_annotation_status",
          { claim_id: claimNumber },
        );
        console.log("Checking annotation status response:", response.data);
        const isProcessed =
          String(response.data?.is_processed).toLowerCase() === "processed";
        if (!isActive) return;
        setAnnotationProcessed(isProcessed);
        if (isProcessed && intervalId) clearInterval(intervalId);
      } catch (error) {
        if (isActive) setAnnotationProcessed(false);
        console.error("Error checking annotation processing status:", error);
      } finally {
        requestInFlight = false;
      }
    };

    setAnnotationProcessed(false);
    checkAnnotationStatus();
    intervalId = setInterval(checkAnnotationStatus, 15000);

    return () => {
      isActive = false;
      clearInterval(intervalId);
    };
  }, [claimNumber]);

  const checkCompareFileExists = async () => {
    if (!claimNumber) {
      console.log("❌ claimNumber missing");
      return;
    }
    try {
      setCheckingCompareFile(true);

      const response = await axios.get("/server/check-s3-file1", {
        params: {
          claimNumber,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      console.log("178", response.data);

      if (response.status === 200) {
        setPreFileExists(response.data.preExists);
        setInvoiceFileExists(response.data.invoiceExists);
      } else {
        setPreFileExists(false);
        setInvoiceFileExists(false);
      }
    } catch (err) {
      console.error("Compare file check error:", err);
      setPreFileExists(false);
      setInvoiceFileExists(false);
    } finally {
      setCheckingCompareFile(false);
    }
  };

  useEffect(() => {
    if (claimNumber) {
      checkCompareFileExists();
    }
  }, [claimNumber]);

  useEffect(() => {
    let interval;

    if (
      (!preFileExists || !invoiceFileExists) &&
      claimNumber &&
      !checkingCompareFile
    ) {
      interval = setInterval(() => {
        checkCompareFileExists();
      }, 30000); // 30 sec
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [preFileExists, invoiceFileExists, claimNumber, checkingCompareFile]);

  useEffect(() => {
    const fetchClaimDetails = async () => {
      try {
        const res = await axios.post("/process_data/claim-details", {
          claimNumber,
        });
        setFormData(res.data);
      } catch (err) {
        console.error("Error fetching claim details:", err);
      }
    };

    if (claimNumber) {
      fetchClaimDetails();
    }
  }, [claimNumber]);

  // NEW: Fetch claim data for Work Approval date
  useEffect(() => {
    const fetchClaimData = async () => {
      try {
        const res = await axios.post("/process_data/claim-data", {
          claimNumber,
        });
        console.log("Claim Data for Work Approval:", res.data);
        setClaimData(res.data);
      } catch (err) {
        console.error("Error fetching claim data:", err);
      }
    };

    if (claimNumber) {
      fetchClaimData();
    }
  }, [claimNumber]);

  // NEW: Fetch Work Approval updated date from S3
  useEffect(() => {
    if (!claimNumber) return;

    getWorkApprovalUpdateDateFromS3(claimNumber).then((date) => {
      setWorkApprovalS3Date(date);
    });
  }, [claimNumber]);

  // FETCH IMAGE DATES FROM AUDIT DATA
  useEffect(() => {
    const fetchImageDates = async () => {
      if (!claimNumber) return;

      try {
        const res = await axios.post("/process_data/get_audit_info", {
          audit_id: claimNumber,
        });

        const auditData = Array.isArray(res.data) ? res.data : [res.data];

        // Extract dates from audit data
        let previewDate = null;
        let docDate = null;
        let uploadDate = null;

        // Find survey related images and their clicked_time
        auditData.forEach((item) => {
          const imageName = item.image_name?.toLowerCase() || "";
          const clickedTime = item.clicked_time;

          // Survey preview image (could be any survey image)
          if (imageName.includes("survey") || imageName.includes("preview")) {
            if (!previewDate && clickedTime) {
              previewDate = clickedTime;
            }
          }

          // Document related
          if (imageName.includes("doc") || imageName.includes("document")) {
            if (!docDate && clickedTime) {
              docDate = clickedTime;
            }
          }

          // Upload related
          if (imageName.includes("upload")) {
            if (!uploadDate && clickedTime) {
              uploadDate = clickedTime;
            }
          }
        });

        // If no specific dates found, use the first available clicked_time
        if (!previewDate && auditData.length > 0) {
          previewDate = auditData[0].clicked_time;
        }

        setImageDates({
          survey_preview_date: previewDate,
          survey_doc_date: docDate || previewDate,
          survey_upload_date: uploadDate || previewDate,
        });

        console.log("Image Dates from Audit:", {
          survey_preview_date: previewDate,
          survey_doc_date: docDate,
          survey_upload_date: uploadDate,
        });
      } catch (err) {
        console.error("Error fetching audit data for dates:", err);
      }
    };

    fetchImageDates();
  }, [claimNumber]);

  useEffect(() => {
    const fetchProgress = async () => {
      if (claimNumber) {
        try {
          const res = await axios.post(
            `/process_data/claim_progress/${claimNumber}`,
          );
          const progressData = res.data;
          setProgressData(progressData);
          console.log("Progress Data:", progressData);

          // Merge image dates with progress data
          const mergedData = {
            ...progressData,
            survey_preview_date:
              imageDates.survey_preview_date ||
              progressData.survey_preview_date,
            survey_doc_date:
              imageDates.survey_doc_date || progressData.survey_doc_date,
            survey_upload_date:
              imageDates.survey_upload_date || progressData.survey_upload_date,
          };

          setProgressData(mergedData);

          let step = 2;

          if (
            progressData?.survey_doc === 1 &&
            progressData?.survey_upload === 1
          )
            step = 3;

          if (step === 3 && progressData?.work_app_update === 1) step = 4;

          if (
            step === 4 &&
            (progressData?.pre_repair_doc === 1 ||
              progressData?.pre_repair_upload === 1)
          )
            step = 5;

          if (
            step === 5 &&
            (progressData?.post_repair_doc === 1 ||
              progressData?.post_repair_upload === 1)
          )
            step = 6;

          if (
            step === 6 &&
            (progressData?.invoice === 1 || progressData?.pre_invoice === 1)
          )
            step = 7;

          if (step === 7 && progressData?.delivery === 1) step = 9;

          setCurrentStep(step);
        } catch (err) {
          console.error("Error fetching claim progress:", err);
        }
      }
    };
    fetchProgress();
  }, [claimNumber, imageDates]);

  /* =========================
     FORMAT DATE FUNCTION - SAME AS InitialAssessmentReportManual
  ========================= */

  const formatDateTimeForPopup = (dateString) => {
    if (!dateString) return "";

    // Expected format: DD-MM-YYYY HH:mm:ss
    const [datePart, timePart] = dateString.split(" ");
    const [day, month, year] = datePart.split("-").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);

    const date = new Date(year, month - 1, day, hour, minute, second);

    return isNaN(date.getTime()) ? "Invalid Date" : date.toLocaleString();
  };

  const formatDateTime = (dateString) => {
    console.log("376", dateString);

    if (
      !dateString ||
      dateString === "null" ||
      dateString === "Not Available" ||
      dateString === "undefined"
    )
      return "Not Available";

    // SPECIAL CASE: Agar S3 ka formatted date hai to as-is return karo
    if (dateString.includes("Dec 2025") || dateString.includes("UTC+05:30")) {
      return dateString;
    }

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "Not Available";

      // Get local time components
      const year = date.getFullYear();
      const month = date.toLocaleString("en-IN", { month: "short" });
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();

      const formattedHours = hours.toString().padStart(2, "0");
      const formattedMinutes = minutes.toString().padStart(2, "0");

      return `${day} ${month} ${year}, ${formattedHours}:${formattedMinutes}`;
    } catch (error) {
      return "Not Available";
    }
  };

  const formatDateTimeUTC = (dateString) => {
    if (
      !dateString ||
      dateString === "null" ||
      dateString === "Not Available" ||
      dateString === "undefined"
    )
      return "Not Available";

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "Not Available";

      // Get UTC time components
      const year = date.getUTCFullYear();
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthName = monthNames[date.getUTCMonth()];
      const day = date.getUTCDate();
      const hours = date.getUTCHours().toString().padStart(2, "0");
      const minutes = date.getUTCMinutes().toString().padStart(2, "0");

      return `${day} ${monthName} ${year}, ${hours}:${minutes} `;
    } catch (error) {
      return "Not Available";
    }
  };
  /* =========================
     GET WORK APPROVAL REPORT DATE - SAME AS InitialAssessmentReportManual
  ========================= */
  // const getWorkApprovalReportDate = () => {
  //   // Return the exact same format as Work Approval Report header
  //   return new Date().toLocaleString('en-IN', {
  //     day: 'numeric',
  //     month: 'short',
  //     year: 'numeric',
  //     hour: 'numeric',
  //     minute: 'numeric',
  //     hour12: true
  //   })
  // }
  const getWorkApprovalReportDate = () => {
    // Get current time without timezone manipulation
    const now = new Date();
    const year = now.getFullYear();
    const month = now.toLocaleString("en-IN", { month: "short" });
    const day = now.getDate();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");

    return `${day} ${month} ${year}, ${formattedHours}:${formattedMinutes}`;
  };

  /* =========================
     STEP INFO DATA FUNCTIONS - UPDATED FOR WORK APPROVAL
  ========================= */

  const getStepInfoData = (stepTitle) => {
    if (!progressData) return [];

    switch (stepTitle) {
      case "Survey Completion":
        return [
          {
            // label: 'Survey Preview',
            date:
              progressData.survey_preview_date ||
              imageDates.survey_preview_date ||
              "Not Available",
            description: "Survey Image Completion Date & Time",
          },
          {
            // label: 'Survey Documents',
            date: progressData.surveycompletion_date_time || "Not Available",
            description: "Survey Documents upload Date & Time",
          },
        ];

      case "Work Approval":
        return [
          {
            // label: 'Work Approval Update',
            date: workApprovalS3Date || "Not Available",
            description: "Update info date and time",
          },
          {
            // label: 'Work Approval Download',
            // Use Work Approval Report date format
            date: getWorkApprovalReportDate(),
            description: "Report download date and time",
          },
        ];

      case "Under Repair/Inspection":
        return [
          // {
          //   label: 'Pre-Repair Upload',
          //   date: progressData.pre_repair_upload_date ||
          //         progressData.pre_repair_upload ||
          //         'Not Available',
          //   description: 'Pre-repair photos upload date and time'
          // },
          {
            // label: 'Pre-Repair Documents',
            date: progressData.prerepair_date_time || "Not Available",
            description: "Documents upload date and time",
          },
        ];

      case "Re Inspection":
        return [
          // {
          //   label: 'Post-Repair Upload',
          //   date: progressData.post_repair_upload_date ||
          //         progressData.post_repair_upload ||
          //         'Not Available',
          //   description: 'Post-repair photos upload date and time'
          // },
          {
            // label: 'Post-Repair Documents',
            date: progressData.postrepair_date_time || "Not Available",
            description: "Documents upload date and time",
          },
        ];

      case "Pre-Invoice/Invoice":
        return [
          {
            // label: 'Pre-Invoice',
            date: progressData.preinvoice_date_time || "Not Available",
            description: "Pre-invoice upload date and time",
          },
          {
            // label: 'Invoice',
            date: progressData.invoice_date_time || "Not Available",
            description: "Invoice upload date and time",
          },
        ];

      case "Delivery Order and Final Assessment":
        return [
          {
            label: "Delivery Order",
            date:
              progressData.delivery_date ||
              progressData.delivery ||
              "Not Available",
            description: "Delivery order creation date and time",
          },
        ];

      case "Payment":
        return [
          {
            label: "Payment Initiated",
            date:
              progressData.payment_initiated_date ||
              progressData.payment_initiated ||
              "Not Available",
            description: "Payment initiation date and time",
          },
        ];

      default:
        return [];
    }
  };

  const handleInfoClick = (step) => {
    const stepData = getStepInfoData(step.title);

    // For Surveyor Appointed special case
    if (step.title === "Surveyor Appointed") {
      setShowServeyorModal(true);
      return;
    }

    // For Claim Intimated special case
    if (step.title === "Claim Intimated") {
      setShowClaimModal(true);
      return;
    }

    // For steps 3-9
    setActiveStepInfo({
      title: step.title,
      data: stepData,
    });
    setShowStepInfoModal(true);
  };

  const isStepCompleted = (stepTitle) => {
    if (!progressData && stepTitle !== "Survey Completion") return false;

    switch (stepTitle) {
      case "Claim Intimated":
      case "Surveyor Appointed":
        return true;

      case "Survey Completion":
        return true;

      case "Work Approval":
        return progressData?.work_app_update === 1;

      case "Under Repair/Inspection":
        return (
          progressData?.pre_repair_doc === 1 ||
          progressData?.pre_repair_upload === 1
        );

      case "Re Inspection":
        return (
          progressData?.post_repair_doc === 1 ||
          progressData?.post_repair_upload === 1
        );

      case "Pre-Invoice/Invoice":
        return progressData?.invoice === 1 || progressData?.pre_invoice === 1;

      case "Delivery Order and Final Assessment":
        return progressData?.delivery === 1;

      case "Payment":
        return progressData?.delivery === 1;

      default:
        return false;
    }
  };

  const isStepEnabled = (stepTitle, action) => {
    if (!progressData) {
      if (
        stepTitle === "Claim Intimated" ||
        stepTitle === "Surveyor Appointed"
      ) {
        return true;
      } else if (stepTitle === "Survey Completion") {
        return action === "upload";
      }
      return false;
    }

    switch (stepTitle) {
      case "Claim Intimated":
      case "Surveyor Appointed":
        return true;

      case "Survey Completion":
        if (action === "upload") {
          return true;
        } else if (action === "documents") {
          return progressData?.survey_upload === 1;
        }
        return false;

      case "Work Approval":
        if (action === "documents") {
          return progressData?.survey_doc === 1;
        } else if (action === "update") {
          return progressData?.survey_doc === 1 && progressData?.survey_upload;
        } else if (action === "download") {
          return progressData?.work_app_update === 1;
        }
        return false;

      case "Under Repair/Inspection":
        if (action === "upload" || action === "documents") {
          return progressData?.work_app_update;
        }
        return false;

      case "Re Inspection":
        if (action === "upload" || action === "documents") {
          return progressData?.work_app_update === 1;
        }
        return false;

      case "Pre-Invoice/Invoice":
        if (action === "update" || action === "download") {
          // return progressData?.invoice === 1 || progressData?.pre_invoice === 1
          return preFileExists || invoiceFileExists;
        }
        return false;

      case "Delivery Order and Final Assessment":
        if (action === "download") {
          return progressData?.delivery === 1;
        }
        return false;

      case "Payment":
        if (action === "proceed") {
          return progressData?.delivery === 1;
        }
        return false;

      default:
        return false;
    }
  };

  const claimSteps = [
    { title: "Claim Intimated", completed: true, date: claimFromState?.date },
    {
      title: "Surveyor Appointed",
      completed: true,
      date: claimFromState?.date,
    },
    {
      title: "Survey Completion",
      completed: true,
      actions: ["upload", "documents"],
    },
    {
      title: "Work Approval",
      completed: false,
      actions: ["update", "download"],
    },
    {
      title: "Under Repair/Inspection",
      completed: false,
      actions: ["upload", "documents"],
    },
    {
      title: "Re Inspection",
      completed: false,
      actions: ["upload", "documents"],
    },
    {
      title: "Pre-Invoice/Invoice",
      completed: false,
      actions: ["download", "update"],
    },
    {
      title: "Delivery Order and Final Assessment",
      completed: false,
      actions: ["download"],
    },
    { title: "Payment", completed: false, actions: ["proceed"] },
  ];

  // Asset paths
  const eye = `${process.env.PUBLIC_URL}/claim-landing/eye.png`;
  const upload = `${process.env.PUBLIC_URL}/claim-landing/upload.png`;
  const download = `${process.env.PUBLIC_URL}/claim-landing/download.png`;
  const proceed = `${process.env.PUBLIC_URL}/claim-landing/proceed.png`;
  const info = `${process.env.PUBLIC_URL}/claim-landing/info.png`;
  const tick = `${process.env.PUBLIC_URL}/claim-landing/tick.png`;
  const pen = `${process.env.PUBLIC_URL}/claim-landing/pen.png`;
  const explain = `${process.env.PUBLIC_URL}/claim-landing/explanation.png`;

  const handleUploadClick = async (step) => {
    const { title } = step;

    if (title === "Survey Completion") {
      if (window.innerWidth < 768) {
        try {
          const response = await axios.post("/process_data/check-survey", {
            claim_id: claimNumber,
          });

          const { survey_upload } = response.data || {};

          if (survey_upload === 1) {
            navigate(`/ticket-page/${claimNumber}`);
          } else {
            // navigate(`/audit/inspection/mode/${claimNumber}`)
            navigate(`/audit/inspection/mode-options/${claimNumber}`);
          }
        } catch (error) {
          console.error("Error fetching survey_upload:", error);
          // navigate(`/audit/inspection/mode/${claimNumber}`)
          navigate(`/audit/inspection/mode-options/${claimNumber}`);
        }
      } else {
        navigate(`/ticket-page/${claimNumber}`);
      }
    } else if (title === "Under Repair/Inspection") {
      navigate(`/under-repair-upload/${claimNumber}`);
    } else if (title === "Re Inspection") {
      navigate(`/re-inspection-upload/${claimNumber}`);
    }
  };

  const handleDocumentStatus = (step) => {
    const { title } = step;

    if (title === "Survey Completion") {
      navigate(`/document-page/${claimNumber}`);
    } else if (title === "Under Repair/Inspection") {
      navigate(`/under-repair-documents/${claimNumber}`);
    } else if (title === "Re Inspection") {
      navigate(`/re-inspection-documents/${claimNumber}`);
    }
  };

  const handleUpdateInfoClick = (step) => {
    const { title } = step;

    if (title === "Work Approval") {
      if (fileExists) {
        navigate(`/update-info/${claimNumber}`, { state: { claimFromState } });
      } else {
        alert(
          `Please wait. File ${claimNumber}.json is not yet available in S3 bucket.`,
        );
        checkFileExists();
      }
    } else if (title === "Pre-Invoice/Invoice") {
      navigate(`/initial-claim-report/${claimNumber}`, {
        state: { claimFromState },
      });
    }
  };

  const handleDownload = (step) => {
    const { title } = step;

    if (title === "Work Approval") {
      navigate(`/initial-report-manual/${claimNumber}`);
    } else if (title === "Pre-Invoice/Invoice") {
      navigate(`/preinvoice-invoice/${claimNumber}`);
    } else if (title === "Delivery Order and Final Assessment") {
      navigate(`/final-claim-report/${claimNumber}`);
    }
  };

  const handleDownloadAll = async () => {
    if (!claimNumber || !downloadPrerequisitesReady || downloadAllLoading)
      return;

    try {
      setDownloadAllLoading(true);
      setDownloadAllError("");

      let annotations = [];
      let manualOcr = {};
      try {
        const annotationResponse = await axios.post(
          "/process_data/get_audit_info",
          { audit_id: claimNumber },
        );
        annotations = Array.isArray(annotationResponse.data)
          ? annotationResponse.data
          : [];
      } catch (error) {
        console.warn("Unable to load image annotations for the PDF:", error);
      }
      try {
        const manualOcrResponse = await axios.post(
          `/process_data/get-manual-updates/${claimNumber}`,
        );
        manualOcr = manualOcrResponse.data?.success
          ? manualOcrResponse.data
          : {};
      } catch (error) {
        console.warn("Unable to load manual OCR updates for the PDF:", error);
      }

      const response = await axios.post(
        `/server/download-claim-package`,
        { claimNumber, annotations, manualOcr },
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "application/zip",
      });
      const downloadUrl = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = `${claimNumber}_package.zip`;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 1000);
      if (response.headers["x-work-approval-report"] === "unavailable") {
        setDownloadAllError(
          "The ZIP was downloaded, but the Work Approval report could not be generated and was not included.",
        );
      }
    } catch (error) {
      console.error("Error downloading claim package:", error);
      if (error.response?.status === 404) {
        setDownloadAllError(
          "No claim files are available yet. Please try again after the survey documents have been uploaded.",
        );
      } else if (error.response?.status >= 500) {
        setDownloadAllError(
          "We couldn't prepare the claim package. Please try again in a moment.",
        );
      } else if (!error.response) {
        setDownloadAllError(
          "Could not connect to the download service. Check your connection and try again.",
        );
      } else {
        setDownloadAllError(
          "The claim package download failed. Please try again.",
        );
      }
    } finally {
      setDownloadAllLoading(false);
    }
  };

  const handleProceedClick = (step) => {
    const { title } = step;

    if (title === "Payment") {
      navigate(`/payment-page/${claimNumber}`);
    }
  };

  const MobileUploadButton = ({
    label,
    docId,
    claimNumber,
    preFileExists,
    invoiceFileExists,
  }) => {
    const [showInput, setShowInput] = useState(false);
    const [uploading, setUploading] = useState(false);

    const isDisabled =
      uploading ||
      (docId === "pre_invoice" ? preFileExists : invoiceFileExists);

    const handleFileChange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result.split(",")[1];
        const contentType = file.type;
        const blobName = `claimDocuments/${claimNumber}_${docId}.pdf`;

        try {
          setUploading(true);
          const uploadRes = await axios.post("/process_data/upload-file", {
            blobName,
            fileContent: base64String,
            contentType,
            claimNumber: claimNumber,
          });

          if (uploadRes.status === 200 || uploadRes.status === 201) {
            if (docId === "pre_invoice") {
              const statusUploadd = await axios.post(
                "/process_data/update_pre_invoice",
                { claimNumber },
              );
            } else if (docId === "invoice") {
              const statusUploadd = await axios.post(
                "/process_data/update_invoice",
                { claimNumber },
              );
            }

            const extractRes = await axios.post(
              "/invoice_data/proxy_invoice_extract",
              {
                file_name: blobName,
                api_name: "invoice_ocr",
                docId: docId,
                claim_number: claimNumber,
                mode: "success",
              },
            );

            if (extractRes.status === 200) {
              console.log(
                "Invoice extracted and saved to S3:",
                extractRes.data,
              );
            } else {
              alert("Invoice extract failed.");
            }
          } else {
            alert("Upload failed. Please try again.");
          }
        } catch (err) {
          console.error("Upload or extraction error:", err);
        } finally {
          setUploading(false);
        }
      };

      reader.readAsDataURL(file);
    };
    const fileRef = useRef(null);
    return (
      <div className="mobile-upload-wrapper">
        {/* <button
          className='btn-update'
          onClick={() => setShowInput(true)}
          disabled={uploading}
        >
          {uploading ? 'Uploading...' : label}
          <img src={upload} alt='upload' className='icon-img icon-upload' />
        </button>
        {showInput && !uploading && (
          <input
            type='file'
            accept='.pdf,.jpg,.jpeg,.png'
            onChange={handleFileChange}
            className='choose_file'
            style={{ marginTop: '8px' }}
          />
        )} */}

        <button
          className="btn-update"
          onClick={() => fileRef.current.click()}
          // disabled={uploading}
          disabled={isDisabled}
        >
          {uploading ? "Uploading..." : label}
          <img src={upload} alt="upload" className="icon-img icon-upload" />
        </button>

        <input
          ref={fileRef}
          type="file"
          accept=".pdf,.jpg,.jpeg,.png,.xls,.xlsx"
          onChange={handleFileChange}
          className="choose_file"
        />
      </div>
    );
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="claim-status-container">
      <div className="claim-status-header">
        <h4 className="claim-status-title">Claim Status List</h4>

        <button
          className="btn-download btn-download-all"
          onClick={handleDownloadAll}
          disabled={
            downloadAllLoading || !claimNumber || !downloadPrerequisitesReady
          }
          title={
            !claimNumber
              ? "Claim number is unavailable"
              : !surveyDocumentsReady
                ? "Available after survey upload and survey documents are complete"
                : !annotationProcessed
                  ? "Available after claim image processing is complete"
                  : "Download all claim files as a ZIP"
          }
        >
          {downloadAllLoading ? "Preparing..." : "Download All"}
          <Download size={16} className="claim-download-icon" />
        </button>
      </div>
      {downloadAllError && (
        <p role="alert" aria-live="polite" className="download-error-message">
          {downloadAllError}
        </p>
      )}

      {claimSteps.map((step, index) => (
        <div
          key={index}
          className={`status-row .step-title  ${
            step.completed ? "completed" : "pending"
          } ${
            isStepCompleted(step.title) ||
            step.title === "Survey Completion" ||
            currentStep >= index + 1
              ? "status-completed"
              : ""
          }
            [
              'Survey Completion',
              'Work Approval',
              'Under Repair/Inspection',
              'Re Inspection',
              'Pre-Invoice/Invoice',
              'Delivery Order and Final Assessment',
              'Payment'
             ].includes(step.title)
              ? 'icon-row'
               : ''
          }`}
        >
          <div className="status-info with-icons">
            {/* Left icon (tick/explain) */}
            <img
              src={
                isStepCompleted(step.title) ||
                step.title === "Survey Completion" ||
                currentStep >= index + 1
                  ? tick
                  : explain
              }
              alt={
                isStepCompleted(step.title) ||
                step.title === "Survey Completion" ||
                currentStep >= index + 1
                  ? "completed"
                  : "pending"
              }
              className="side-icon left"
              style={{
                width: "20px",
                height: "20px",
                objectFit: "contain",
              }}
            />

            {/* Step Title */}
            <span>{step.title}</span>

            {/* Info (i) button for ALL steps */}
            {!["Delivery Order and Final Assessment", "Payment"].includes(
              step.title,
            ) && (
              <img
                src={info}
                alt="info"
                className="side-icon right clickable"
                onClick={() => handleInfoClick(step)}
                style={{
                  width: "20px",
                  height: "20px",
                  objectFit: "contain",
                  cursor: "pointer",
                }}
              />
            )}
          </div>

          {step.date && <span className="timestamp">{step.date}</span>}

          {step.actions && (
            <div className="action-buttons-claim">
              {/* "Pre-Invoice" and "Invoice" buttons ONLY in mobile view */}
              {step.title === "Pre-Invoice/Invoice" && isMobile ? (
                <>
                  <MobileUploadButton
                    label="Pre-Invoice"
                    docId="pre_invoice"
                    claimNumber={claimNumber}
                    preFileExists={preFileExists}
                    invoiceFileExists={invoiceFileExists}
                  />
                  <MobileUploadButton
                    label="Invoice"
                    docId="invoice"
                    claimNumber={claimNumber}
                    preFileExists={preFileExists}
                    invoiceFileExists={invoiceFileExists}
                  />
                </>
              ) : step.title === "Work Approval" ? (
                <>
                  {step.actions.includes("update") && !isMobile && (
                    <button
                      className="btn-update"
                      onClick={() => handleUpdateInfoClick(step)}
                      disabled={
                        !isStepEnabled(step.title, "update") ||
                        !fileExists ||
                        isCheckingFile
                      }
                      title={
                        isCheckingFile
                          ? "Checking file availability in database..."
                          : !fileExists
                            ? `File claims/${claimNumber} data not found`
                            : "Click to update information"
                      }
                    >
                      {isCheckingFile ? (
                        <>
                          Checking...
                          <div className="loading-spinner"></div>
                        </>
                      ) : (
                        <>
                          Update Info
                          <img
                            src={pen}
                            alt="Pen"
                            className="icon-img icon-update"
                          />
                        </>
                      )}
                    </button>
                  )}
                  {step.actions.includes("download") && (
                    <button
                      className="btn-download"
                      onClick={() => handleDownload(step)}
                      disabled={!isStepEnabled(step.title, "download")}
                    >
                      Download
                      <img
                        src={download}
                        alt="Download"
                        className="icon-img icon-download"
                      />
                    </button>
                  )}
                </>
              ) : (
                <>
                  {step.actions.includes("download") && (
                    <button
                      className="btn-download"
                      onClick={() => handleDownload(step)}
                      disabled={!isStepEnabled(step.title, "download")}
                    >
                      Download
                      <img
                        src={download}
                        alt="Download"
                        className="icon-img icon-download"
                      />
                    </button>
                  )}
                  {step.actions.includes("update") && !isMobile && (
                    <button
                      className="btn-update"
                      onClick={() => handleUpdateInfoClick(step)}
                      disabled={!isStepEnabled(step.title, "update")}
                    >
                      Update Info
                      <img
                        src={pen}
                        alt="Pen"
                        className="icon-img icon-update"
                      />
                    </button>
                  )}
                </>
              )}

              {step.actions.includes("upload") && (
                <button
                  className="btn-upload"
                  onClick={() => handleUploadClick(step)}
                  disabled={!isStepEnabled(step.title, "upload")}
                >
                  {window.innerWidth < 768 ? (
                    <>
                      <span>Capture</span>
                      <img
                        src={`${process.env.PUBLIC_URL}/claim-landing/camera.png`}
                        alt="Camera"
                        className="icon-img icon-upload"
                        style={{ width: "16px", height: "16px" }}
                      />
                    </>
                  ) : (
                    <>
                      <span>Preview</span>
                      <img
                        src={`${process.env.PUBLIC_URL}/claim-landing/eye.png`}
                        alt="Eye"
                        className="icon-img icon-upload"
                        style={{
                          width: "18px",
                          height: "18px",
                          color: "#ff2a6aff",
                          objectFit: "contain",
                        }}
                      />
                    </>
                  )}
                </button>
              )}

              {step.actions.includes("documents") && (
                <button
                  className="btn-documents"
                  onClick={() => handleDocumentStatus(step)}
                  disabled={!isStepEnabled(step.title, "documents")}
                >
                  Documents
                  <img
                    src={upload}
                    alt="Upload"
                    className="icon-img icon-documents"
                  />
                </button>
              )}

              {step.actions.includes("proceed") && (
                <button
                  className="btn-proceed"
                  onClick={() => handleProceedClick(step)}
                  disabled={!isStepEnabled(step.title, "proceed")}
                >
                  Proceed
                  <img
                    src={proceed}
                    alt="Proceed"
                    className="icon-img icon-proceed"
                  />
                </button>
              )}
            </div>
          )}
        </div>
      ))}

      {/* ================= MODALS ================= */}

      {/* STEP INFO MODAL (for steps 3-9) */}
      {showStepInfoModal && activeStepInfo && (
        <div className="claim-modal-backdrop" onClick={closeAllModals}>
          <div
            className="claim-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="claim-modal-close"
              onClick={() => setShowStepInfoModal(false)}
            >
              ×
            </button>

            <h4>{activeStepInfo.title} Details</h4>

            <div className="claim-modal-form">
              {activeStepInfo.data && activeStepInfo.data.length > 0 ? (
                activeStepInfo.data.map((item, i) => (
                  <div className="form-group" key={i}>
                    <label>{item.label}</label>
                    <div className="info-description">{item.description}</div>
                    <input
                      type="text"
                      readOnly
                      value={
                        // sift is condition me UTC h
                        activeStepInfo.title === "Re Inspection" ||
                        activeStepInfo.title === "Pre-Invoice/Invoice"
                          ? formatDateTimeUTC(item.date) // UTC format
                          : item.label === "Work Approval Download"
                            ? item.date // Directly show the formatted date
                            : formatDateTime(item.date) // IST format by default
                      }
                      placeholder="Not Available"
                    />
                  </div>
                ))
              ) : (
                <div className="no-data-message">
                  <p>No information available for this step yet.</p>
                  <p>Check back later for updates.</p>
                </div>
              )}
            </div>

            {/* DEBUG INFO - Remove in production */}
            {/* {activeStepInfo.title === 'Work Approval' && (
              <div style={{ 
                marginTop: '10px', 
                padding: '8px', 
                backgroundColor: '#f5f5f5', 
                fontSize: '11px',
                borderTop: '1px solid #ddd',
                color: '#666'
              }}>
                <strong>Work Approval Download Date:</strong> {getWorkApprovalReportDate()}
              </div>
            )}  */}
          </div>
        </div>
      )}

      {/* CLAIM INTIMATED MODAL */}
      {showClaimModal && (
        <div className="claim-modal-backdrop" onClick={closeAllModals}>
          <div
            className="claim-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="claim-modal-close"
              onClick={() => setShowClaimModal(false)}
            >
              ×
            </button>

            <h4>Claim Intimated Details</h4>

            <form className="claim-modal-form">
              <div className="form-group">
                <label>Claim Intimation Date and Time</label>
                <input
                  type="text"
                  value={formatDateTimeForPopup(formData.date)}
                  readOnly
                />
              </div>

              <div className="form-group">
                <label>Claim Number</label>
                <input
                  type="text"
                  value={formData.claim_number || claimNumber || "N/A"}
                  readOnly
                />
              </div>
            </form>
          </div>
        </div>
      )}

      {/* SURVEYOR APPOINTED MODAL */}
      {showSurveyorModal && (
        <div className="claim-modal-backdrop" onClick={closeAllModals}>
          <div
            className="claim-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="claim-modal-close"
              onClick={() => setShowServeyorModal(false)}
            >
              ×
            </button>

            <h4>Surveyor Appointed Details</h4>

            <form className="claim-modal-form">
              <div className="form-group">
                <label>Surveyor Appointed Name</label>
                <input type="text" value="Surveyor's AI" readOnly />
              </div>

              <div className="form-group">
                <label>Email ID</label>
                <input
                  type="text"
                  value={formData.email_id || "N/A"}
                  readOnly
                />
              </div>

              <div className="form-group">
                <label>Mobile Number</label>
                <input
                  type="text"
                  value={formData.phone_number || "N/A"}
                  readOnly
                />
              </div>

              <div className="form-group">
                <label>Appointed Date and Time</label>
                <input
                  type="text"
                  value={formatDateTimeForPopup(formData.date)}
                  readOnly
                />
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};
export default ClaimStatusList;
